const FacebookGamingIcon = (props) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 32 32"
      version="1.1"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>facebookgaming</title>
      <path
        fill="inherit"
        d="M11.414 20.599h10.397v10.397h9.185v-19.594h-19.582zM1.004 1.004v29.991h19.582v-9.185h-10.397v-11.622h20.807v-9.185z"
      ></path>
    </svg>
  )
}

export default FacebookGamingIcon
